import { useMemo, useState } from "react";
import { Badge } from "./components/Badge";
import { Button } from "./components/Button";
import { categoryCounts, marketplaceGuides } from "./data/marketplaceGuides";

function categoryTextTone(category) {
  if (category === "Longevity") return "text-kin-green-dark";
  if (category === "Hormone Balance" || category === "Hormones") return "text-kin-green-dark";
  if (category === "Cardio Health") return "text-kin-orange";
  if (category === "Cognitive Boost") return "text-kin-lavender";
  if (category === "Immune Support") return "text-kin-gold-dark";
  if (category === "Sleep and Recovery" || category === "Sleep & Recovery")
    return "text-kin-lavender";
  if (category === "Metabolic Health") return "text-kin-orange";
  if (category === "Gut Health") return "text-kin-gold-dark";
  return "text-kin-olive";
}

function GuideGlyph({ category, className = "h-4 w-4" }) {
  if (category === "Longevity") {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path
          d="M4 12c1.7-3 3.2-4.5 5-4.5 3 0 4 9 7 9 1.8 0 3.3-1.5 4.9-4.5-1.6-3-3.1-4.5-4.9-4.5-3 0-4 9-7 9-1.8 0-3.3-1.5-5-4.5Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (category === "Hormone Balance" || category === "Hormones") {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path
          d="M12 5.25 18.5 16.5h-13L12 5.25Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (category === "Cardio Health") {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path
          d="M12 19.5s-6.75-3.75-6.75-8.5a3.75 3.75 0 0 1 6.75-2.25A3.75 3.75 0 0 1 18.75 11c0 4.75-6.75 8.5-6.75 8.5Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (category === "Immune Support") {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path
          d="M12 4.5 18 7v5c0 4.25-2.5 6.9-6 8-3.5-1.1-6-3.75-6-8V7l6-2.5Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
        <path
          d="M12 8.25v6M9 11.25h6"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (category === "Cognitive Boost") {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path
          d="M9.75 6.75a3 3 0 0 0-3 3v.5a2.5 2.5 0 0 0 0 5v.5a3 3 0 0 0 3 3h4.5a3 3 0 0 0 3-3v-.5a2.5 2.5 0 0 0 0-5v-.5a3 3 0 0 0-3-3h-4.5Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (category === "Sleep and Recovery" || category === "Sleep & Recovery") {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path
          d="M16.5 5.25a7 7 0 1 0 2.25 13.65A7.75 7.75 0 0 1 16.5 5.25Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (category === "Metabolic Health") {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path
          d="M12 4.5c3.5 3.8 5.25 6.3 5.25 8.75a5.25 5.25 0 1 1-10.5 0c0-2.45 1.75-4.95 5.25-8.75Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (category === "Gut Health") {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path
          d="M10.5 4.5v4.25a2.75 2.75 0 0 1-2.75 2.75 2.75 2.75 0 0 0 0 5.5 2.75 2.75 0 0 1 2.75 2.75V19.5M13.5 4.5v4.25a2.75 2.75 0 0 0 2.75 2.75 2.75 2.75 0 0 1 0 5.5 2.75 2.75 0 0 0-2.75 2.75V19.5"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="4.5" stroke="currentColor" strokeWidth="1.7" />
    </svg>
  );
}

function _ArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" aria-hidden="true">
      <path
        d="M4.5 12h15m0 0-5.5-5.5m5.5 5.5L14 17.5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="1.7" />
      <path d="m16 16 3.5 3.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
}

function RatingIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="currentColor" aria-hidden="true">
      <path d="m12 3.75 2.43 4.92 5.43.79-3.93 3.84.93 5.42L12 16.16l-4.86 2.56.93-5.42-3.93-3.84 5.43-.79L12 3.75Z" />
    </svg>
  );
}

function InstallIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" aria-hidden="true">
      <path
        d="M12 4.5v9m0 0 3.25-3.25M12 13.5 8.75 10.25M5.25 16.5h13.5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FeaturedGuideCard({ guide }) {
  return (
    <article className="kin-surface rounded-xl p-5 sm:p-6">
      <div className="flex items-center justify-between">
        <span className="inline-flex items-center rounded-md border border-kin-olive/12 bg-kin-white/80 px-2 py-1 text-[10px] font-semibold tracking-[0.09em] uppercase text-kin-muted">
          {guide.category}
        </span>
        <span className="inline-flex items-center gap-1 text-xs font-medium text-kin-muted">
          <RatingIcon />
          {guide.rating}
        </span>
      </div>

      <div className="mt-4 flex items-start gap-3">
        <span
          className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-kin-olive/12 bg-kin-white ${categoryTextTone(guide.category)}`}
        >
          <GuideGlyph category={guide.category} className="h-4 w-4" />
        </span>

        <div className="min-w-0">
          <a
            href={`/private/design/marketplace/${guide.slug}`}
            className="block truncate text-lg font-semibold text-kin-black transition hover:text-kin-green-dark"
          >
            {guide.name}
          </a>
          <p className="text-sm text-kin-muted">{guide.creator}</p>
        </div>
      </div>

      <p className="mt-3 text-sm leading-relaxed text-kin-body/90">{guide.description}</p>

      <div className="mt-4 flex items-center justify-between">
        <span className="inline-flex items-center gap-1 text-xs font-medium text-kin-muted">
          <InstallIcon />
          {guide.installs} installs
        </span>
        <div className="flex items-center gap-2">
          <a href={`/private/design/marketplace/${guide.slug}`}>
            <Button variant="secondary" size="small">
              Details
            </Button>
          </a>
          <a
            href={`mailto:sverre@kin.health?subject=Install%20Guide%20-%20${encodeURIComponent(guide.name)}`}
          >
            <Button size="small">Install</Button>
          </a>
        </div>
      </div>
    </article>
  );
}

function CategoryCard({ category }) {
  return (
    <a
      href="#directory"
      className="group inline-flex items-center gap-2 rounded-full border border-kin-olive/12 bg-kin-white/80 py-2 pl-2.5 pr-4 transition hover:border-kin-olive/18 hover:bg-kin-white/94"
    >
      <span
        className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-kin-olive/10 bg-kin-cream ${categoryTextTone(category.name)}`}
      >
        <GuideGlyph category={category.name} className="h-3.5 w-3.5" />
      </span>
      <span className="text-sm font-semibold text-kin-black">{category.name}</span>
      <span className="text-xs text-kin-muted">{category.count}</span>
    </a>
  );
}

function GuideRow({ guide }) {
  return (
    <article className="rounded-xl border border-kin-olive/12 bg-kin-white/78 px-4 py-3 backdrop-blur-sm transition hover:border-kin-olive/18 hover:bg-kin-white/92">
      <div className="grid gap-3 lg:grid-cols-[minmax(0,1.25fr)_minmax(0,1fr)_auto] lg:items-center">
        <div className="flex min-w-0 items-center gap-3">
          <span
            className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-kin-olive/12 bg-kin-white ${categoryTextTone(guide.category)}`}
          >
            <GuideGlyph category={guide.category} className="h-4 w-4" />
          </span>
          <div className="min-w-0">
            <a
              href={`/private/design/marketplace/${guide.slug}`}
              className="block truncate text-lg font-semibold text-kin-black transition hover:text-kin-green-dark"
            >
              {guide.name}
            </a>
            <p className="truncate text-sm text-kin-muted">
              {guide.creator} · {guide.category}
            </p>
          </div>
        </div>

        <p className="text-sm leading-relaxed text-kin-body/86 lg:max-w-lg">{guide.description}</p>

        <div className="flex flex-wrap items-center gap-2 lg:justify-end">
          <span className="inline-flex items-center gap-1 rounded-md border border-kin-olive/12 bg-kin-white/90 px-2 py-1 text-xs font-medium text-kin-muted">
            <RatingIcon />
            {guide.rating}
          </span>
          <span className="inline-flex items-center gap-1 rounded-md border border-kin-olive/12 bg-kin-white/90 px-2 py-1 text-xs font-medium text-kin-muted">
            <InstallIcon />
            {guide.installs}
          </span>
          <a href={`/private/design/marketplace/${guide.slug}`}>
            <Button variant="secondary" size="small">
              Details
            </Button>
          </a>
          <a
            href={`mailto:sverre@kin.health?subject=Install%20Guide%20-%20${encodeURIComponent(guide.name)}`}
          >
            <Button size="small">Install</Button>
          </a>
        </div>
      </div>
    </article>
  );
}

export default function MarketplacePage() {
  const featured = useMemo(
    () => marketplaceGuides.filter((guide) => guide.featured).slice(0, 3),
    [],
  );

  const [queryInput, setQueryInput] = useState("");
  const [query, setQuery] = useState("");

  const filteredGuides = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return marketplaceGuides;

    return marketplaceGuides.filter((guide) => {
      const haystack = [
        guide.name,
        guide.creator,
        guide.category,
        guide.description,
        guide.requiredData.join(" "),
      ]
        .join(" ")
        .toLowerCase();

      return haystack.includes(q);
    });
  }, [query]);

  const onSearch = (event) => {
    event.preventDefault();
    setQuery(queryInput);
  };

  return (
    <div className="relative min-h-screen overflow-x-clip bg-kin-sunrise">
      <div className="pointer-events-none fixed inset-0 -z-30 bg-kin-sunrise animate-drift" />
      <div className="pointer-events-none fixed -left-24 -top-10 -z-20 h-[28rem] w-[28rem] rounded-full bg-kin-lavender/10 blur-3xl" />
      <div className="pointer-events-none fixed right-[-7rem] top-24 -z-20 h-[24rem] w-[24rem] rounded-full bg-kin-gold/8 blur-3xl" />

      <header className="px-6 pt-6 sm:px-8">
        <div className="mx-auto flex max-w-6xl items-center justify-between rounded-xl border border-kin-olive/12 bg-kin-white/78 px-4 py-3 backdrop-blur-md sm:px-5">
          <div>
            <p className="font-serif text-2xl font-bold leading-none text-kin-black">
              Kin Marketplace
            </p>
            <p className="mt-1 text-[10px] font-semibold tracking-[0.14em] uppercase text-kin-muted">
              Expert Health AI Guide Directory
            </p>
          </div>

          <div className="flex items-center gap-2">
            <a href="/private/design/mobile">
              <Button variant="secondary" size="small">
                Mobile
              </Button>
            </a>
            <a href="/private/design/landing">
              <Button variant="secondary" size="small">
                Product
              </Button>
            </a>
            <a href="#directory">
              <Button size="small">Directory</Button>
            </a>
          </div>
        </div>
      </header>

      <main className="px-6 pb-16 pt-10 sm:px-8 sm:pb-20 sm:pt-14">
        <section className="mx-auto max-w-6xl text-center">
          <h1 className="font-serif text-5xl font-bold tracking-tight text-kin-black sm:text-6xl">
            Discover Guides.
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-kin-body/90">
            Install expert health AI guides directly into your vault. Built by researchers, doctors,
            and practitioners.
          </p>

          <form
            onSubmit={onSearch}
            className="mx-auto mt-7 flex w-full max-w-3xl gap-2 rounded-xl border border-kin-olive/12 bg-kin-white/82 p-2"
          >
            <label htmlFor="marketplace-search" className="sr-only">
              Search guides
            </label>
            <div className="relative flex-1">
              <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-kin-muted/75">
                <SearchIcon />
              </span>
              <input
                id="marketplace-search"
                type="search"
                value={queryInput}
                onChange={(event) => setQueryInput(event.target.value)}
                placeholder="Search guides, creators, categories, biomarkers"
                className="h-11 w-full rounded-lg border border-kin-olive/10 bg-kin-white px-4 pl-9 text-sm text-kin-black placeholder:text-kin-muted/65 focus:border-kin-green/40 focus:outline-none"
              />
            </div>
            <Button type="submit" variant="secondary" size="medium">
              Search
            </Button>
          </form>

          {query.trim() ? (
            <p className="mt-3 text-sm text-kin-muted">
              {filteredGuides.length} result{filteredGuides.length === 1 ? "" : "s"} for "{query}"
            </p>
          ) : null}
        </section>

        <section className="mx-auto mt-14 max-w-6xl">
          <div className="mb-5 flex items-end justify-between">
            <h2 className="font-serif text-4xl font-bold text-kin-black">Highlighted Skills</h2>
            <Badge className="normal-case tracking-normal">{featured.length} featured</Badge>
          </div>
          <div className="grid gap-4 lg:grid-cols-3">
            {featured.map((guide) => (
              <FeaturedGuideCard key={guide.slug} guide={guide} />
            ))}
          </div>
        </section>

        <section className="mx-auto mt-14 max-w-6xl">
          <h2 className="text-center font-serif text-3xl font-bold text-kin-black">
            Browse by Category
          </h2>
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {categoryCounts.map((category) => (
              <CategoryCard key={category.name} category={category} />
            ))}
          </div>
        </section>

        <section id="directory" className="mx-auto mt-14 max-w-6xl">
          <div className="mb-4 flex items-center justify-between">
            <h2 className="font-serif text-4xl font-bold text-kin-black">Guide Directory</h2>
            <Badge className="normal-case tracking-normal">{filteredGuides.length} guides</Badge>
          </div>

          <div className="space-y-2">
            {filteredGuides.map((guide) => (
              <GuideRow key={guide.slug} guide={guide} />
            ))}
          </div>

          {filteredGuides.length === 0 ? (
            <article className="kin-surface mt-4 rounded-xl p-5 text-center">
              <p className="text-sm text-kin-body">
                No guides matched your search. Try a broader keyword.
              </p>
            </article>
          ) : null}
        </section>
      </main>
    </div>
  );
}
